if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();

        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        } else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }

      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }

      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }

      get focusElement() {
        return this.acceptButton || this.declineButton || super.focusElement;
      }

      connectedCallback() {
        super.connectedCallback();
        this.reshowAbortController = new AbortController();

        const gesture = this.querySelector('gesture-element');
        const closeButton = this.querySelector('.drawer__close');
        gesture?.setAttribute('tabindex', '-1');
        closeButton?.setAttribute('hidden', '');
        closeButton?.setAttribute('tabindex', '-1');
        closeButton?.setAttribute('aria-hidden', 'true');
        this.bindPolicyControls();

        document.addEventListener(
          'click',
          (event) => {
            const trigger = event.target instanceof Element
              ? event.target.closest('a[href="#shopifyReshowConsentBanner"]')
              : null;
            if (!trigger) return;

            event.preventDefault();
            this.show(trigger);
          },
          { signal: this.reshowAbortController.signal }
        );
      }

      disconnectedCallback() {
        this.reshowAbortController?.abort();
        super.disconnectedCallback();
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        if (this.testMode) {
          this.load(this.delay);
          return;
        }

        window.Shopify.loadFeatures([
          {
            name: 'consent-tracking-api',
            version: '0.1',
            onLoad: this.onConsentLibraryLoaded.bind(this),
          },
        ]);
      }

      load(delay) {
        if (Shopify.designMode) return;

        setTimeout(() => this.show(), delay * 1000);
      }

      bindPolicyControls() {
        if (this.policyListenersBound) return;
        this.policyListenersBound = true;

        if (this.acceptButton) this.on(this.acceptButton, 'click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.on(this.declineButton, 'click', this.declinePolicy.bind(this));
      }

      hide() {
        const trackingConsent = window.Shopify.customerPrivacy?.getTrackingConsent?.();
        if (!Shopify.designMode && !this.policyDecisionMade && trackingConsent === 'no_interaction') return;

        return super.hide();
      }

      acceptPolicy() {
        this.policyDecisionMade = true;
        window.Shopify.customerPrivacy?.setTrackingConsent(true, this.noop);
        this.hide();
      }

      declinePolicy() {
        this.policyDecisionMade = true;
        window.Shopify.customerPrivacy?.setTrackingConsent(false, this.noop);
        this.hide();
      }

      onConsentLibraryLoaded() {
        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

        if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.load(this.delay);
        }
      }

      noop() {}

      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }

      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}
